import { useNavigate } from 'react-router-dom';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { CheckCircle2, Eye, Edit, List } from 'lucide-react';

interface ConversionSuccessDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  jobId: string;
  jobNumber: string;
}

export function ConversionSuccessDialog({
  open,
  onOpenChange,
  jobId,
  jobNumber,
}: ConversionSuccessDialogProps) {
  const navigate = useNavigate();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <CheckCircle2 className="h-6 w-6 text-success" />
            Lead Successfully Converted!
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-4">
          <p className="text-muted-foreground">
            Job <span className="font-semibold text-foreground">{jobNumber}</span> has been created. What would you like to do next?
          </p>

          <div className="grid gap-3">
            <Button
              variant="default"
              onClick={() => {
                navigate(`/jobs/${jobId}`);
                onOpenChange(false);
              }}
            >
              <Eye className="h-4 w-4 mr-2" />
              View Job Details
            </Button>

            <Button
              variant="outline"
              onClick={() => {
                navigate('/jobs');
                onOpenChange(false);
              }}
            >
              <List className="h-4 w-4 mr-2" />
              Go to Jobs List
            </Button>

            <Button
              variant="ghost"
              onClick={() => onOpenChange(false)}
            >
              Stay on Lead Detail
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
